import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { useAppSelector } from '../redux/hooks';
import styled from 'styled-components';

interface BackdropCircularProgressComponentProps {
  
}

const TransparentModal = styled(Modal)`
  .modal-content {
    background-color: transparent !important;  /* Make modal background transparent */
    border: none !important;  /* Remove border */
  }

  .modal-header,
  .modal-footer {
    display: none;  /* Hide header and footer */
  }
`;

const BackdropCircularProgressComponent: React.FC<BackdropCircularProgressComponentProps> = (prop) => {

  const isCircularProgressOpen = useAppSelector((state)=>state.uielements.progress.isCircularProgressOpen);

  return (
    <TransparentModal
      show={isCircularProgressOpen}
      backdrop="static"
      centered
      animation={true}
      keyboard={false}
    >
      <Modal.Body className="text-center">
        <Spinner animation="border" variant="primary" />
      </Modal.Body>
    </TransparentModal>
  );
}
 
export default BackdropCircularProgressComponent;